import { useAuth } from '../contexts/AuthContext';
import { UserRole } from '@speico-app/shared';

/**
 * Hook to check if the current user is an admin (ADMIN or SUPER_ADMIN)
 */
export const useIsAdmin = (): boolean => {
  const { user } = useAuth();
  
  if (!user) {
    return false;
  }
  
  return user.role === UserRole.ADMIN || user.role === UserRole.SUPER_ADMIN;
};

